import React from 'react';
import { TablePagination, Box } from '@mui/material';

interface CustomTablePaginationProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rowsPerPageOptions?: number[];
  labelRowsPerPage?: string;
  component?: React.ElementType;
}

const CustomTablePagination: React.FC<CustomTablePaginationProps> = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [5, 10, 25, 50, 100],
  labelRowsPerPage = 'Lignes par page:',
  component = 'div',
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        borderTop: '1px solid rgba(224, 224, 224, 1)',
        backgroundColor: 'background.paper',
      }}
    >
      <TablePagination
        component={component}
        count={count}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={rowsPerPageOptions}
        labelRowsPerPage={labelRowsPerPage}
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} sur ${count}`}
        sx={{
          width: '100%',
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
            marginTop: 2,
            marginBottom: 2,
          },
          '.MuiTablePagination-select': {
            paddingTop: 1,
            paddingBottom: 1,
          },
          '.MuiTablePagination-toolbar': {
            minHeight: 52,
          },
        }}
      />
    </Box>
  );
};

export default CustomTablePagination;
